
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import {
	activityPersonalPKRankingList
} from '@/api/toBApi';
@Component({
	name: '',
	components: {
		PageFooter
	}
})

export default class ProductList extends Vue {
	@Prop({ default: {} }) msg!: any
	private keywords = ''
	private tablelist: any = []
	private tableloading = false
	private pageSize = 20
	private pageNo = 1
	private total = 0
	private choosemsg: any = this.msg

	private mounted() {
		this.gettablelist()
	}

	private returnchoosemsg() {
		return this.choosemsg
	}
	private checkchange(e, row) {
		this.tablelist = this.tablelist.map(v => {
			v.IsChoose = false
			if (v.Id == row.Id) {
				v.IsChoose = true
				this.choosemsg = v
			}
			return v
		})
	}
	private async gettablelist() {
		try {
			this.tableloading = true
			let res = await activityPersonalPKRankingList({
				Keywords: this.keywords.trim(),
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize
			})
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results.map(v => {
					if (v.Id == this.choosemsg.Id) {
						v.IsChoose = true
						this.choosemsg = v
					} else {
						v.IsChoose = false
					}
					return v
				})
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
	private changePage(e) {
		this.pageNo = e
		this.gettablelist()
	}
	private doSearch() {
		this.pageNo = 1
		this.gettablelist()
	}
}
